'use strict';

var count = 0;
module.exports = function uuid() {
  return 'react-tinymce-' + count++;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-tinymce/lib/helpers/uuid.js
// module id = 702
// module chunks = 0